import React, { useRef } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  IconButton,
  Stack
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { BootstrapTooltip } from "components/BootstrapTooltip";

interface Props {
  open: boolean;
  onClose: () => void;
  onFileSelect: (event: any) => void;
  loading?: boolean;
}

export const ImportSelectionDialog = (props: Props) => {
  const { open, onClose, onFileSelect, loading = false } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  const handleDownloadExample = () => {
    const link = document.createElement('a');
    link.href = '/static/files/example_equipment_import.xlsx';
    link.download = 'example_equipment_import.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleFileUploadClick = () => {
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleFileChange = (event: any) => {
    onFileSelect(event);
    onClose();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6">
              Импорт оборудования
            </Typography>
            <BootstrapTooltip title="Закрыть">
              <IconButton size="small" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </BootstrapTooltip>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Выберите действие для импорта оборудования из Excel файла
          </Typography>

          <Stack spacing={2}>
            <Button
              variant="outlined"
              size="large"
              startIcon={<DownloadIcon />}
              onClick={handleDownloadExample}
              sx={{ py: 2 }}
            >
              Скачать пример файла
            </Button>

            <Button
              variant="contained"
              size="large"
              startIcon={<UploadFileIcon />}
              onClick={handleFileUploadClick}
              disabled={loading}
              sx={{ py: 2 }}
            >
              Загрузить файл с оборудованием
            </Button>
          </Stack>

          <input
            type="file"
            hidden
            ref={inputRef}
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onChange={handleFileChange}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} color="inherit">
            Отмена
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};